import { Component } from '@verndale/core';
import Cookies from 'js-cookie';

class PopupForm extends Component {
  setupDefaults() {
    this.dom = {
      close: this.$el.find('.modal-close a')
    };

    this.behavior = this.$el.data('behavior');
    this.isSigned = this.$el.data('isSigned');
    this.cookieName = this.$el.data('cookieName');
    this.delay = +this.$el.data('delay') * 1000;
    this.cookieVisitedName = `${this.cookieName}-visited`;
    this.cookieValue = Cookies.get(this.cookieName);
    this.cookieVisitedValue = parseInt(Cookies.get(this.cookieVisitedName)) || 0;

    $(window).on('mouseout', e => {
      if (e.clientY <= 0) {
        this.open();
      }
    });
    if (this.behavior === 'article') {
      Cookies.set(this.cookieVisitedName, this.cookieVisitedValue + 1);
    }

    if (this.shouldDisplayOnCategory()) {
      this.open();
    } else if (this.delay > 0) {
      this.timeout = setTimeout(() => this.open(), this.delay);
    }
  }

  addListeners() {
    this.dom.close.on('click', this.close.bind(this));
    $('body').on('click', '.modal-close a', () => {
      if (this.videoOpened) {
        this.videoOpened = false;
        this.open();
      }
    })

    $('.launch-media_modal').on('click', () => {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.videoOpened = true;
      }
    })
  }

  shouldDisplayOnCategory() {
    const currentUrl = window.location.href;
    const previousUrl = document.referrer;

    return this.cookieVisitedValue >= 3 && previousUrl.includes(currentUrl);
  }

  open() {
    if (!this.isSigned && !this.cookieValue) {
      this.$el.addClass('popup-form--open');
      $('body').addClass('popup-form--opened');
    }
  }

  close() {
    this.cookieValue = true;
    Cookies.set(this.cookieName, this.cookieValue);

    this.$el.removeClass('popup-form--open');
    $('body').removeClass('popup-form--opened');
  }

}

export default PopupForm;
